export const WOMEN_URL_PATH = "women";
export const NEW_IN_TODAY_WOMEN_CATEGORY_ID = "51163";
export const MEN_URL_PATH = "men";
export const NEW_IN_TODAY_MEN_CATEGORY_ID = "51164";
